<template>
  <div class="container-fluid">
    <div class="card search-card">
      <div class="card-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <div class="form-row">
            <!-- 面談日期 -->
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="">面談日期</label>
                <ValidationProvider
                  :rules="{ dateRangeRequired: true }"
                  v-slot="{ errors }"
                >
                  <el-date-picker
                    class="w-100"
                    type="daterange"
                    :clearable="false"
                    :picker-options="{
                      disabledDate: $common.disabledDateAfterToday,
                    }"
                    range-separator="-"
                    start-placeholder="開始日期"
                    end-placeholder="結束日期"
                    v-model="interviewDateRange"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <!-- 單位面試主管 -->
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="">單位面試主管</label>
                <el-select
                  class="w-100"
                  filterable
                  clearable
                  placeholder="請選擇"
                  v-model="searchCondition.InterviewSupervisor"
                >
                  <el-option
                    v-for="supervisor in supervisorOptions"
                    :key="supervisor.Guid"
                    :label="supervisor.Name"
                    :value="supervisor.Name"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <!-- HR 面試人員 -->
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="">HR 面試人員</label>
                <el-select
                  class="w-100"
                  filterable
                  clearable
                  placeholder="請選擇"
                  v-model="searchCondition.InterviewHR"
                >
                  <el-option
                    v-for="supervisor in supervisorOptions"
                    :key="supervisor.Guid"
                    :label="supervisor.Name"
                    :value="supervisor.Name"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- 職缺編號 -->
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for=""> 職缺編號 </label>
                <el-input
                  clearable
                  placeholder="請輸入關鍵字"
                  v-model.trim="searchCondition.manpowerDemandNo"
                />
              </div>
            </div>
            <!-- 職缺名稱 -->
            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="">職缺名稱</label>
                <el-input
                  clearable
                  placeholder="請輸入關鍵字"
                  v-model.trim="searchCondition.manpowerDemandName"
                />
              </div>
            </div>

            <div class="col-sm-12 col-md-3">
              <div class="form-group">
                <label for="">應聘者</label>
                <el-input
                  clearable
                  placeholder="請輸入關鍵字"
                  v-model.trim="searchCondition.interviewee"
                />
              </div>
            </div>

            <div class="col-sm-12 col-md-4">
              <button
                type="button"
                class="btn btn-primary"
                style="margin-top: 30px"
                @click="
                  (currentPage = 1),
                    handleSubmit(getInterviewed)
                "
              >
                查詢
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                style="margin-top: 30px; margin-left: 10px"
                @click="
                  searchCondition = {};
                  interviewDateRange = [
                    new Date(dayjs().subtract(7, 'day').format('YYYY-MM-DD')),
                    new Date($common.getToday()),
                  ];
                "
              >
                清除
              </button>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="personList.length > 0">
      <span class="mr-2">共計：{{ totalPerson }}人</span>
      <CardStyle @changeStyle="changeStyle" />
    </div>

    <!-- 人員卡片 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        v-for="(person, index) in personList"
        :key="index"
        class="person-card infinite-list-item"
      >
        <PersonCard ref="personCard" :showCheckbox="false" :person="person">
          <template v-slot:tag="{ props }">
            <div class="result">{{ props.ApprovalResult }}</div>
          </template>

          <template v-slot:middleContent="{ props }">
            <table>
              <tr>
                <th>職缺名稱</th>
                <td>{{ props.ManpowerDemandName }}</td>
              </tr>
              <tr>
                <th>應徵職務</th>
                <td>{{ props.Position }}</td>
              </tr>
              <tr>
                <th>面談時間</th>
                <td>{{ $common.dateFormatter(props.InterviewDate) }}</td>
              </tr>
              <tr>
                <th>面談地點</th>
                <td>{{ props.InterviewPlace }}</td>
              </tr>
              <tr>
                <th>單位面試主管</th>
                <td>{{ props.InterviewSupervisor[0] }}</td>
              </tr>
              <tr>
                <th>HR 面試人員</th>
                <td>{{ props.InterviewHR[0] }}</td>
              </tr>
            </table>
          </template>

          <template v-slot:buttonGroup="{ props }">
            <button type="button" @click="showDetailModal(props)">
              檢視資訊
            </button>
            <button
              type="button"
              @click="getInterviewRecordHistory(props.MatchId)"
            >
              面談紀錄歷程
            </button>
          </template>
        </PersonCard>
      </div>
    </div>

    <!-- 分頁 -->
    <el-pagination
      v-if="personList.length > 0"
      background
      layout="prev, pager, next"
      :total="totalPerson"
      :page-size="9"
      @current-change="changePage"
    >
    </el-pagination>

    <!-- 面談紀錄歷程 Modal -->
    <div
      class="modal fade"
      id="interviewRecordHistoryModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <span>面談紀錄歷程</span>
          </div>
          <div class="modal-body">
            <ValidationObserver v-slot="{ handleSubmit }">
              <div class="d-flex align-items-start" style="margin-bottom: 10px">
                <ValidationProvider
                  ref="addInterviewSupervisor"
                  class="w-100"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <multiselect
                    :options="supervisorOptions"
                    :close-on-select="false"
                    multiple
                    tagPlaceholder=""
                    selectLabel=""
                    selectedLabel=""
                    deselectLabel=""
                    label="Name"
                    track-by="Guid"
                    placeholder="請選擇加簽人員"
                    v-model="InterviewSupervisor"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
                <button
                  class="btn btn-primary"
                  style="margin: 2px 0 0 10px; width: 70px"
                  @click="handleSubmit(addInterviewRecord)"
                >
                  加簽
                </button>
              </div>
            </ValidationObserver>
            <div class="evaluation-person-info">
              <div>
                <label for="">姓名</label>
                <div>{{ recordList.Interviewee }}</div>
              </div>

              <div>
                <label for="">面談日期</label>
                <div>
                  {{ $common.dateFormatter(recordList.InterviewDate) }}
                </div>
              </div>

              <div v-for="score in recordList.Scores" :key="score.Seq">
                <label for="">{{ score.Name }}</label>
                <div>{{ score.Score }}</div>
              </div>
            </div>

            <template
              v-if="
                recordList.InterviewRecords &&
                recordList.InterviewRecords.length > 0
              "
            >
              <div style="display: flex; margin-top: 2px">
                <div class="evaluation-body fixed">
                  <div class="evaluation-name">單位面試主管</div>
                  <div
                    v-for="item in recordList.InterviewRecords[0]
                      .InterviewRecordAppraisals"
                    :key="item.Name"
                    class="evaluation-field"
                  >
                    {{ item.Name }}
                  </div>

                  <template v-if="recordList.ResumeType === 'IDL'">
                    <div class="evaluation-field">職等</div>
                  </template>

                  <div
                    class="evaluation-field"
                    style="height: 150px; overflow-y: auto"
                  >
                    面談說明
                  </div>

                  <div
                    class="evaluation-field"
                    style="height: 150px; overflow-y: auto"
                  >
                    個人備註
                  </div>
                  <div class="evaluation-field">面談結果</div>

                </div>

                <div style="flex: 1; min-width: 1px">
                  <carousel
                    :key="Math.random()"
                    :items="recordList.InterviewRecords.length"
                    :nav="true"
                    :dots="false"
                  >
                    <div
                      v-for="record in recordList.InterviewRecords"
                      class="evaluation-body"
                      :key="record.InterviewSupervisorId"
                      @dblclick="$common.copyText($event)"
                    >
                      <div class="evaluation-name">
                        {{ record.InterviewSupervisor }} ({{
                          record.InterviewUserType
                        }})
                      </div>

                      <div
                        v-for="item in record.InterviewRecordAppraisals"
                        class="evaluation-field"
                        :key="item.Name"
                      >
                        <template
                          v-if="item.Result !== '-' && item.Result !== '未填寫'"
                        >
                          <el-tooltip
                            v-if="item.Remark"
                            class="item"
                            effect="dark"
                            :content="item.Remark"
                            placement="right"
                          >
                            <span>
                              {{ item.Result }}
                            </span>
                          </el-tooltip>
                          <span v-else>{{ item.Result }}</span>
                        </template>
                        <span v-else>{{ item.Result }}</span>
                      </div>

                      <template v-if="recordList.ResumeType === 'IDL'">
                        <!-- 職等 -->
                        <div class="evaluation-field">
                          {{ record.ExpectedJobLevel }}
                        </div>
                      </template>

                      <!-- 面談備註 -->
                      <div
                        class="evaluation-field"
                        style="height: 150px; overflow-y: auto"
                      >
                        <div>
                          {{ record.Remark }}
                        </div>
                      </div>
                      <!-- 個人備註 -->
                      <div
                        class="evaluation-field"
                        style="height: 150px; overflow-y: auto"
                      >
                        <div>
                          {{ record.PersonalRemark }}
                        </div>
                      </div>
                      <!-- 面談結果 -->
                      <div class="evaluation-field">
                        <div>
                          {{ record.InterviewResult }}
                        </div>
                      </div>

                    </div>
                  </carousel>
                </div>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 各資訊總覽 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF"></eva-icon>
                履歷
              </span>
            </a>
            <div
              class="close-show-detail"
              @click="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              />
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import carousel from "vue-owl-carousel2";
import Logo from "@/components/company/Logo.vue";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 卡片樣式
import CardStyle from "@/components/back/Card/CardStyle";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";

export default {
  name: "Restricted_Progress_Interviewed",

  components: {
    carousel,
    Logo,
    PersonCard,
    CardStyle,
    IdlResume,
    DlResume,
  },
  data() {
    return {
      // 卡片顯示樣式 有 block / list 兩種
      gridStyle: "block",

      // 查詢條件
      interviewDateRange: [],
      searchCondition: {},

      // 檢視資訊
      MatchId: null,
      ResumeId: null,
      isShowDetail: false, // 預設不顯示
      detailCurrentPage: 0, // 點擊選項
      ResumeType: null, // 履歷種類

      supervisorOptions: [],

      // 面談紀錄歷程
      recordList: {},

      // 加簽主管列表
      InterviewSupervisor: [],

      // 人員卡片列表
      personList: [],

      // 分頁
      totalPerson: 0, // 共幾筆
      currentPage: 1, // 當前第幾頁
    };
  },

  methods: {
    // 取得 已面談(依據使用者所屬部門)
    getInterviewed() {
      this.updateLoading(true);
      this.$store.commit("ScrollTop", true);

      this.$api.supervisor
        .getInterviewedPaging(
          {
            ...this.searchCondition,
            interviewDateStart: this.interviewDateRange
              ? this.$common.dateFormatter(this.interviewDateRange[0])
              : null,
            interviewDateEnd: this.interviewDateRange
              ? this.$common.dateFormatter(this.interviewDateRange[1])
              : null,
            Page: this.currentPage,
            PerPage: 9,
          },
          this.$cookies.get("userId")
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.status === 200) {
              if (response.data.Quantity > 0) {
                this.totalPerson = response.data.Quantity;
                this.personList = response.data.Datas;
                this.$store.commit("ScrollTop", false);
              }
            }
          }
          this.updateLoading(false);
        });
    },

    // 換頁
    changePage(page) {
      this.currentPage = page;
      this.getInterviewed();
    },

    // 取得 面談紀錄歷程(部門主管)
    getInterviewRecordHistory(MatchId) {
      this.updateLoading(true);

      this.MatchId = MatchId;
      this.InterviewSupervisor = [];
      this.$refs.addInterviewSupervisor.reset();

      this.$api.approveInterview
        .getInterviewRecordForSupervisor(this.MatchId)
        .then((response) => {
          if (response.status === 200) {
            this.recordList = response.data;
            let interviewSupervisorId = response.data.InterviewRecords.map(
              (element) => element.InterviewSupervisorId
            );
            this.supervisorOptions = this.supervisorOptions.filter(
              (element) => interviewSupervisorId.indexOf(element.Guid) === -1
            );
          }
          this.updateLoading(false);
          $("#interviewRecordHistoryModal").modal("show");
        });
    },

    // 加簽 API
    addInterviewRecord() {
      const vm = this;
      const api = `${window.endpoints.api}/Recruitment/AddInterviewRecord`;

      const data = {
        InterviewId: vm.recordList.InterviewId,
        InterviewSupervisor: vm.InterviewSupervisor.map(
          (element) => element.Guid
        ),
        CreateUser: vm.$cookies.get("userName"),
      };

      this.updateLoading(true);

      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            this.updateLoading(false);

            vm.personList.forEach((item, index, arr) => {
              if (item.InterviewId === data.InterviewId) {
                arr[index].InterviewSupervisor = vm.InterviewSupervisor.map(
                  (element) => element.Name
                );
              }
            });

            vm.$notify({
              title: "成功",
              message: "加簽成功",
              type: "success",
              duration: 2500,
            });
            vm.getInterviewRecordHistory(vm.MatchId);
          }
        })
        .catch((error) => {
          this.updateLoading(false);
          vm.$notify({
            title: "加簽失敗",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 檢視資訊 Modal
    showDetailModal(person) {
      this.MatchId = person.MatchId;
      this.ResumeId = person.ResumeId;
      this.ResumeType = person.ResumeType;
      this.isShowDetail = true;
    },

    // 日期不得大於今日
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    async getData() {
      try {
        // 取得 主管列表
        const backgroundUser =
          await this.$api.backgroundUser.getBackgroundUser();
        this.supervisorOptions = backgroundUser.data.map((user) => {
          return {
            Guid: user.UserId,
            Name: user.Name,
          };
        });
      } catch (error) {
        this.$notify({
          title: error.name,
          message: error.message + "請聯繫系統管理員",
          type: "error",
          duration: 0,
        });
      }
    },

    // 卡片樣式
    changeStyle(style) {
      this.gridStyle = style;
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  watch: {
    isShowDetail: function (e) {
      if (!e) {
        this.detailCurrentPage = 0;
      }
    },
  },

  created() {
    this.interviewDateRange = [
      new Date(this.$common.getLastWeek()),
      new Date(this.$common.getToday()),
    ];
    this.getInterviewed();
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
/deep/ input[placeholder="Go to page"] {
  display: none;
}
</style>
